import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/baoshi'
  },
  // {
  //   path: '/report',
  //   name: 'Report',
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ '../views/report/index.vue')
  // },
  // {
  //   path: '/repair',
  //   name: 'Repair',
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ '../views/repair/index.vue')
  // },
  {
    path: '/baoshi',
    name: 'BaoShi',
    redirect: '/baoshi/add',
    component: () =>
      import(/* webpackChunkName: "about" */ '@/views/BaoShi/index.vue'),
    children: [
      {
        path: 'add',
        name: 'BsAdd',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/views/BaoShi/add.vue'),
        meta: { title: '新增报事', active: 0 }
      },
      {
        path: 'ok',
        name: 'BsOk',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/BaoShi/success.vue'),
        meta: { title: '报事成功', active: 0 }
      },
      {
        path: 'list',
        name: 'BsList',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/BaoShi/list.vue'),
        meta: { title: '报事列表', active: 1 }
      },
      {
        path: 'detail',
        name: 'BsDetail',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/BaoShi/detail.vue'),
        meta: { title: '报事详情', active: 1 }
      },
      {
        path: 'my-scoring',
        name: 'MyScoring',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/views/BaoShi/my-scoring.vue'),
        meta: { title: '添加评价', active: 2 }
      },
      {
        path: 'my-detail',
        name: 'MyDetail',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/views/BaoShi/my-detail.vue'),
        meta: { title: '我的详情', active: 2 }

      },
      {
        path: 'my-list',
        name: 'MyList',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/views/BaoShi/my-list.vue'),
        meta: { title: '我的列表', active: 2 }
      },
      {
        path: 'add-replay',
        name: 'addReplay',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/views/BaoShi/add-replay.vue'),
        meta: { title: '添加回复', active: 2 }
      }

    ]
  },
  {
    path: '/baoxiu',
    name: 'BaoXiu',
    redirect: '/baoxiu/add',
    component: () =>
      import(/* webpackChunkName: "about" */ '@/views/BaoXiu/index.vue'),
    children: [
      {
        path: 'add',
        name: 'BxAdd',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/views/BaoXiu/add.vue'),
        meta: { title: '新增报修', active: 0 }
      },
      {
        path: 'ok',
        name: 'BxOk',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/BaoXiu/success.vue'),
        meta: { title: '报修成功', active: 0 }
      },
      {
        path: 'list',
        name: 'BxList',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/BaoXiu/list.vue'),
        meta: { title: '报修列表', active: 1 }
      },
      {
        path: 'detail',
        name: 'BxDetail',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/BaoXiu/detail.vue'),
        meta: { title: '报修详情', active: 1 }
      },
      {
        path: 'my-scoring',
        name: 'MyBxScoring',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/views/BaoXiu/my-scoring.vue'),
        meta: { title: '添加评价', active: 2 }
      },
      {
        path: 'my-detail',
        name: 'MyBxDetail',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/views/BaoXiu/my-detail.vue'),
        meta: { title: '我的详情', active: 2 }
      },
      {
        path: 'my-list',
        name: 'MyBxList',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/views/BaoXiu/my-list.vue'),
        meta: { title: '我的列表', active: 2 }
      },
      {
        path: 'add-replay',
        name: 'addBxReplay',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/views/BaoXiu/add-replay.vue'),
        meta: { title: '添加回复', active: 2 }
      }

    ]
  },
  {
    path: '/jiaofei',
    name: 'JiaoFei',
    redirect: '/jiaofei/djfx',
    component: () =>
      import(/* webpackChunkName: "about" */ '@/views/JiaoFei/index.vue'),
    children: [
      {
        path: 'djfx',
        name: 'DJFX',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/views/JiaoFei/djfx.vue'),
        meta: { title: '待缴费项', active: 0 }
      },
      {
        path: 'djfx-detail',
        name: 'DJFXDETAIL',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/views/JiaoFei/djfx-detail.vue'),
        meta: { title: '待缴费项-支付', active: 0 }
      },
      {
        path: 'jfjl',
        name: 'JFJL',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/views/JiaoFei/jfjl.vue'),
        meta: { title: '缴费记录', active: 1 }
      },
      {
        path: 'jfjl-detail',
        name: 'JFJLDETAIL',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/views/JiaoFei/jfjl-detail.vue'),
        meta: { title: '缴费记录-详细', active: 1 }
      },
      {
        path: 'pay-result',
        name: 'PayResult',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/views/JiaoFei/pay-result')
      }
    ]
  },
  {
    path: '/renovation',
    name: 'Renovation',
    redirect: '/agreement',
    component: () =>
      import('@/views/renovation/index.vue'),
    children: [
      {
        path: '/agreement',
        name: 'Agreement',
        component: () =>
          import('@/views/renovation/Agreement.vue'),
        meta: { title: '装修申请' }
      },
      {
        path: '/agreementSecond',
        name: 'AgreementSecond',
        component: () =>
          import('@/views/renovation/AgreementSecond.vue'),
        meta: { title: '装修申请' }
      },
      {
        path: '/SubmitSuccess',
        name: 'SubmitSuccess',
        component: () =>
          import('@/views/renovation/SubmitSuccess.vue'),
        meta: { title: '提交完成' }
      },
      {
        path: '/renovationList',
        name: 'renovationList',
        component: () =>
          import('@/views/renovation/renovationList.vue'),
        meta: { title: '装修记录列表' }
      },
      {
        path: '/RenovationDetail/:id',
        name: 'RenovationDetail',
        component: () =>
          import('@/views/renovation/RenovationDetail.vue'),
        meta: { title: '装修详情' }
      }
    ]
  },
  {
    path: '/test',
    name: 'Test',
    component: () =>
      import('@/views/test/index.vue'),
    meta: { title: '装修申请' }
  },
  {
    path: '/park',
    name: 'Park',
    redirect: '/park/index',
    component: () =>
      import(/* webpackChunkName: "about" */ '@/views/Park/index.vue'),
    children: [
      {
        path: 'master',
        name: 'master',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/views/Park/master.vue'),
        meta: { title: '停车缴费', active: 0 }
      },
      {
        path: 'master-check',
        name: 'master-check',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/views/Park/master-check.vue'),
        meta: { title: '确认订单', active: 0 }
      },
      {
        path: 'record',
        name: 'record',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/views/Park/record.vue'),
        meta: { title: '缴费记录', active: 1 }
      },
      {
        path: 'record-detail',
        name: 'record-detail',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/views/Park/record-detail.vue'),
        meta: { title: '缴费明细', active: 1 }
      },
      {
        path: 'pack',
        name: 'pack',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/views/Park/pack.vue'),
        meta: { title: '包期预缴', active: 2 }
      },
      {
        path: 'pack-cardetail',
        name: 'pack-cardetail',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/views/Park/pack-cardetail.vue'),
        meta: { title: '车辆详情', active: 2 }
      },
      {
        path: 'pack-addcar',
        name: 'pack-addcar',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/views/Park/pack-addcar.vue'),
        meta: { title: '添加车辆', active: 2 }
      },
      {
        path: 'result-pay',
        name: 'result-pay',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/views/Park/result-pay.vue'),
        meta: { title: '支付结果' }
      },
      {
        path: 'result-check',
        name: 'result-check',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/views/Park/result-check.vue'),
        meta: { title: '查询结果' }
      }
    ]
  }
]

const NeedTopPage = ['RenovationDetail']

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // console.log(to.name, '去往路径')
    if (NeedTopPage.includes(to.name)) {
      // console.log('属于')
      // return 期望滚动到哪个的位置
      return { x: 0, y: 0 }
    }
  }

})
// 消除重复路由
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
